import { render, staticRenderFns } from "./ModalCnae.vue?vue&type=template&id=55285e17&scoped=true"
import script from "./ModalCnae.vue?vue&type=script&lang=js"
export * from "./ModalCnae.vue?vue&type=script&lang=js"
import style0 from "./ModalCnae.vue?vue&type=style&index=0&id=55285e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55285e17",
  null
  
)

export default component.exports